import React, { useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import authService from '../../services/AuthService';
import { ADMIN_APP_NAME, REACT_APP_LOGIN_URL, REDIRECT_ERROR_TYPE } from '../../constants';

export default function App() {
  const navigate = useNavigate();

  useEffect(() => {
    authService.getUser()
      .then(user => {
        if (user === null) {
          authService.login({ state: { pathname: window.location.pathname } });
        } else {
          navigate('/users');
        }
      })
      .catch(() => {
        window.location.href = `${REACT_APP_LOGIN_URL}?clientId=${ADMIN_APP_NAME}&${REDIRECT_ERROR_TYPE.unauthorized}=1`;
      });
  }, []);

  return (
    <React.Fragment></React.Fragment>
  );
}
